import { CompetenzaFattureOutpuDto, CompetenzeMeseAnnoFattureOutputDto } from '@api/client';
import { createReducer } from '@reduxjs/toolkit';
import { getCompetenzeMeseAnnoByFatturaCicloAttivo, getCompetenzeMeseAnnoCicloAttivo } from './actions';

interface InitialState {
  competenzeMeseAnnoByFatturaCicloAttivo: CompetenzaFattureOutpuDto | undefined;
  competenzeMeseAnnoCicloAttivo: CompetenzeMeseAnnoFattureOutputDto[] | undefined;
}

const initialState: InitialState = {
  competenzeMeseAnnoByFatturaCicloAttivo: undefined,
  competenzeMeseAnnoCicloAttivo: undefined,
};

export const fattureControllerReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(getCompetenzeMeseAnnoByFatturaCicloAttivo.fulfilled, (state, action) => {
      state.competenzeMeseAnnoByFatturaCicloAttivo = action.payload;
    })
    .addCase(getCompetenzeMeseAnnoCicloAttivo.fulfilled, (state, action) => {
      state.competenzeMeseAnnoCicloAttivo = action.payload;
    });
});
